import { Outlet } from "react-router-dom";
import MagicNav from "@/components/MagicNav";
import { LayoutDashboard, Users, ClipboardList, Library, GraduationCap, IndianRupee, CalendarCheck, BookOpen, Bell, BookCopy, Printer, UserCog, CalendarClock } from "lucide-react";

const items = [
  { key: "dashboard", to: "/school", end: true, label: "Dashboard", icon: LayoutDashboard },
  { key: "students", to: "/school/students", label: "Students", icon: Users },
  { key: "admissions", to: "/school/admissions", label: "Admissions", icon: ClipboardList },
  { key: "academics", to: "/school/academics", label: "Academics", icon: Library },
  { key: "exams", to: "/school/exams", label: "Exams & Progress", icon: GraduationCap },
  { key: "fees", to: "/school/fees", label: "Fees", icon: IndianRupee },
  { key: "inventory", to: "/school/inventory", label: "Inventory", icon: BookCopy },
  { key: "attendance", to: "/school/attendance", label: "Attendance", icon: CalendarCheck },
  { key: "homework", to: "/school/homework", label: "Homework", icon: BookOpen },
  { key: "academic-year", to: "/school/academic-year", label: "Academic Year", icon: CalendarClock, roles: ["school_admin"] },
  { key: "staff", to: "/school/staff", label: "Staff", icon: UserCog, roles: ["school_admin"] },
  { key: "whatsapp", to: "/school/whatsapp", label: "WhatsApp", icon: Bell },
  { key: "print", to: "/school/print-designs", label: "Print Designs", icon: Printer },
];

export default function SchoolLayout() {
  return (
    <div className="ep-aurora min-h-screen bg-slate-950">
      <MagicNav items={items} />
      <main className="mx-auto max-w-7xl px-5 py-8 pb-28">
        <Outlet />
      </main>
    </div>
  );
}
